import { TableRow, TableCell, Typography } from '@mui/material';
import { Link } from 'react-router';
import { Api } from '../../api';
import { format } from 'date-fns';

interface B2BOrganisationsRowProps {
  organisation: Api.Organisation.V_ListAsAdmin;
}

export default function B2BOrganisationsRow({
  organisation,
}: B2BOrganisationsRowProps) {
  return (
    <TableRow
      component={Link}
      to={`/b2b/${organisation.id}`}
      sx={{
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {organisation.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{organisation.licenceCount}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {organisation.claimedLicenceCount}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {format(organisation.createdAt, 'dd MMM yyyy')}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
